module.exports = __webpack_public_path__ + "img/op_proposal.736470e.png";